/* eslint-disable  */
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './AffirmAsLowAs.module.scss';

import AffirmForm from '../AffirmForm';

import { AFFIRM_PRICE_CONDITIONAL_THRESHOLD, AFFIRM_PRICE_LOWER_THRESHOLD, AFFIRM_PRICE_UPPER_THRESHOLD } from '../../utils/common/constants';

/**
 * Despite being named Affirm, this widget displays all possible BNPL options
 * and supports A/B testing.
 */
const AffirmAsLowAs = ({ placement = 'category', total = 0, skus = '' }) => {
  useEffect(() => {
    // TODO: Check if this useEffect can be removed.
    if (window.affirm) {
      try {
        // React DOM change is happening after affirm reading the data. So DOM has to be changed forecefully
        // to make data-promo-id avaialble to affirm
        // if (skus?.length > 0) {
        //   document.getElementById('affirm-price-update').setAttribute('data-sku', dataSku);
        // }
        window.affirm?.ui.refresh();
      } catch (e) {
        console.log('AFFIRM ERROR', e);
      }
    }
  }, [total]);

  const showAffirm = useMemo(() => {
    if (!total) {
      return false;
    }
    if (
      total < AFFIRM_PRICE_LOWER_THRESHOLD ||
      total > AFFIRM_PRICE_UPPER_THRESHOLD
    ) {
      return false;
    }
    if (
      total >= AFFIRM_PRICE_CONDITIONAL_THRESHOLD &&
      total < AFFIRM_PRICE_UPPER_THRESHOLD
    ) {
      return true;
    }
    return true;
  }, [total]);

  return (
    showAffirm && (
      <>
        <AffirmForm />
        <div className={styles['affirm']}>
          <span
            id='affirm-price-update'
            data-testid='affirm-as-low-as'
            data-amount={total}
            className={classnames(
              'affirm-as-low-as',
              styles['affirm-as-low-as-wrap'],
            )}
            data-page-type={placement}
          ></span>
        </div>
      </>
    )
  );
};

AffirmAsLowAs.propTypes = {
  placement: PropTypes.string,
  total: PropTypes.number,
};

export default AffirmAsLowAs;
